// -----------------------------------------------------------------------------
// requirejs configuration
// -----------------------------------------------------------------------------

require.config({
	urlArgs: 'bust=' + (new Date()).getTime(),
	deps: [ 'init' ]
});

define("bundle", function(){});

